import React from 'react';
import { JsonPropsType } from '../../component-loader';
import { Endpoint } from './types';

interface PlaygroundAppProps {
  endpoints: Endpoint[];
}

export function PlaygroundApp(props: JsonPropsType) {
  const { endpoints } = props.jsonObject as PlaygroundAppProps;

  return (
    <div className="playground-app">
      <p className="text-muted">
        Endpoints disponibles
      </p>
      <div className="row g-3">
        {endpoints.map((endpoint) => (
          <div key={endpoint.slug} className="col-md-6 col-lg-4">
            <div className="card h-100">
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">{endpoint.name}</h5>
                <code className="d-block mb-3 text-secondary small">
                  POST
                  {' '}
                  {endpoint.path}
                </code>
                <a
                  href={`/playground/${endpoint.slug}/`}
                  className="btn btn-primary btn-sm mt-auto align-self-start"
                >
                  Probar
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
